export const iconFontAwesomeTextformattingICursor = (
	<i className="fa-solid fa-i-cursor"></i>
);
